"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import PricingModal from "@/components/modals/pricing-modal";
import { ShareNoteModal } from "@/features/ai-notetaker/components/share-note-modal";
import { AuthModal } from "@/features/auth/components/auth-modal";
import { FeedbackModal } from "@/features/feedback/components/feedback-modal";
import UploadFileModal from "@/features/files/components/upload-file-modal";
import { AddStudySetsToFolderModal } from "@/features/folders/components/add-studysets-to-folder-modal";
import { AddToFolderModal } from "@/features/folders/components/add-to-folder-modal";
import { NewFolderModal } from "@/features/folders/components/new-folder-modal";
import { NewQuestionModal } from "@/features/questions/components/new-question-modal";
import { ImageCompatibilityWarningModal } from "@/features/quiz/components/image-compatibility-warning-modal";
import { CancellationModal } from "@/features/settings/components/cancellation/cancellation-modal";
import { NewStudySetDrawerModal } from "@/features/studysets/components/new-studyset-drawer-dialog";
import { ShareStudysetModal } from "@/features/studysets/components/share-studyset-modal";
import { ImagePreview } from "../modals/image-preview-modal";
import SuccessPopup from "../modals/success-popup";

const PdfModal = dynamic(() => import("../modals/pdf-modal"), {
  ssr: false,
});

export const ModalProvider = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) return null;

  // Check if current date is before August 31, 2025
  // const now = new Date();
  // const fallSaleEndDate = new Date("2025-08-31T23:59:59");
  // const isFallSaleActive = now < fallSaleEndDate;

  return (
    <>
      <NewFolderModal />
      <AddToFolderModal />
      <AddStudySetsToFolderModal />
      <AuthModal />
      {/* {isFallSaleActive ? <FallSaleModal /> : <PricingModal />} */}
      <PricingModal />
      <UploadFileModal />
      <NewQuestionModal />
      <SuccessPopup />
      <ShareStudysetModal />
      <ShareNoteModal />
      <ImagePreview />
      <NewStudySetDrawerModal />
      <ImageCompatibilityWarningModal />
      <PdfModal />
      <FeedbackModal />
      <CancellationModal />
    </>
  );
};
